import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'
import HeaderCheckout from '~/components/templates/HeaderCheckout'
import MainPublic from '~/components/templates/MainPublic'
import PreRegistrationForm from '~/components/templates/PreRegistrationForm'
import { CheckoutContext } from '~/contexts/CheckoutContext'
import { ParamsContext } from '~/contexts/ParamsContext'
import { useScreen } from '~/hooks/useScreen'
import { handleServerSideProps } from '~/services/handleServerSideProps'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const response = await handleServerSideProps(context)

  return response
}

export default function Checkout({
  partnerData,
  redirectUrlFromV2ToV3,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const router = useRouter()
  const { step, setStep, isHeaderCheckoutShown } = useContext(CheckoutContext)
  const { getParams, cartData, isCartLoading, mutateCart, route } = useContext(ParamsContext)

  useEffect(() => {
    const { campaign, classes, token } = getParams()

    if ((!step || step === 'courses') && (campaign || classes || token)) {
      // this is to avoid the default screen (like in '/' or '/checkout')
      setStep('preRegistration')
    }
  }, [setStep, step, getParams])
  useEffect(() => {
    if (!isCartLoading && !cartData && route !== '/courses/[slug]') {
      mutateCart()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutateCart, route])

  // if we have a redirectUrlFromV2ToV3, we redirect to that url (basically add classes/campaign to the url)
  useEffect(() => {
    if (redirectUrlFromV2ToV3) {
      router.push(redirectUrlFromV2ToV3)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const defaultScreen = (
    <PreRegistrationForm
      title="Boas-vindas"
      subTitle={`Informe seu CPF para recuperar um pedido ou veja todos os cursos de ${partnerData?.partnerName}.`}
      variantButtonText="Ver todos os cursos"
      isButtonGroup
    />
  )

  const { currentScreen } = useScreen({
    defaultScreen,
  })

  return (
    <MainPublic title={partnerData?.partnerName || ''} ssrPartnerData={partnerData}>
      {isHeaderCheckoutShown && step && <HeaderCheckout />}

      {typeof window !== 'undefined' && currentScreen}
    </MainPublic>
  )
}
